import React from "react";
import img1 from "../../assets/Tenable.png";


export const Summary = () => {
  return (
    <section className="tenable-summary-section">
      <div className="tenable-summary-container">
        {/* Image Column */}
        <div className="tenable-image-wrapper">
          <img 
            src={img1} 
            alt="Tenable cybersecurity solutions illustration" 
            className="tenable-hero-image"
          />
        </div>

        {/* Content Column */}
        <div className="tenable-content-wrapper">
          <h2>Tenable: Proactive Cybersecurity</h2>
          <p>
            Tenable provides cybersecurity solutions that assess, manage, and
            enhance an organization's cybersecurity posture. We help organizations 
            maintain a strong security foundation by ensuring the visibility and 
            protection of their digital assets against evolving cyber risks.
          </p>
          <p>
            Its core products offer **vulnerability management**, **continuous monitoring**, 
            and **risk assessment** to proactively identify and mitigate cyber threats before they can be exploited.
          </p>
        </div>
      </div>
    </section>
  );
};